import { Barcode, Eye, File, FolderPlus } from "lucide-react";
import LabelsLayout from "../componants/labels/LabelsLayout";
import { Link } from "react-router-dom";
import { useCollection } from "../hooks/useCollection";

const experts = [
  {
    name: "Marie Dubois",
    title: "Digital Health Expert",
    country: "Côte d’Ivoire",
    imageSrc: "/images/experts/marie-dubois.jpg", // chemin vers l'image
  },
  {
    name: "Thierry Nkonga",
    title: "Regulatory Specialist",
    country: "Cameroun",
    imageSrc: "/images/experts/thierry-nkonga.jpg",
  },
  {
    name: "Sophie Amani",
    title: "Data Analyst",
    country: "Kenya",
    imageSrc: "/images/experts/sophie-amani.jpg",
  },
  {
    name: "David Touré",
    title: "Health Policy Advisor",
    country: "Mali",
    imageSrc: "/images/experts/david-toure.jpg",
  },
  {
    name: "David Touré",
    title: "Health Policy Advisor",
    country: "Mali",
    imageSrc: "/images/experts/david-toure.jpg",
  },
  {
    name: "David Touré",
    title: "Health Policy Advisor",
    country: "Mali",
    imageSrc: "/images/experts/david-toure.jpg",
  },
];

export default function HomeLabels() {
  const { documents, loading, error } = useCollection("experts");
  return (
    <LabelsLayout>
      <section className="container mx-auto px-6 py-10">
        <div className="mb-8">
          <h2 className="md:text-2xl text-[1rem] font-bold mb-4">
            Base de données CEISNA
          </h2>
          <p className="mb-3 text-gray-700">
            La création d’une base de données africaine sur les dispositifs de
            santé numérique (CEISNA) est un pilier essentiel pour harmoniser les
            pratiques et assurer la transparence dans le secteur de la santé en
            Afrique.
          </p>
          <p className="mb-3 text-gray-700">
            CEISNA offre une vision dynamique du cycle de vie des dispositifs
            connectés et numériques mis à disposition dans les pays africains.
            Elle centralise et traite les informations relatives aux dispositifs
            et aux acteurs (fabricants, distributeurs, autorités réglementaires)
            via des systèmes électroniques intégrés.
          </p>
          <p className="text-gray-700">
            L’objectif est de renforcer la transparence, de faciliter l’accès
            aux données pour les professionnels de santé et le grand public, et
            d’améliorer la coordination entre les États membres africains et les
            partenaires internationaux.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="md:text-2xl text-[1rem] font-bold mb-4">
            Le Cadre d’Évaluation et d’Impact Sanitaire Numérique Africain
          </h2>
          <p className="mb-3 text-gray-700">
            Un référentiel de confiance pour des solutions de santé numérique
            adaptées, sécurisées et impactantes.
          </p>
          <p className="mb-3 text-gray-700">
            Le Cadre d’Évaluation et d’Impact Sanitaire Numérique Africain
            (CEISNA) est un référentiel structurant, développé pour évaluer,
            certifier et valoriser les applications mobiles de santé et les
            solutions numériques médicales conçues pour l’Afrique.
          </p>
          <p className="mb-3 text-gray-700">
            Ce cadre repose sur une approche progressive et contextuelle,
            adaptée aux réalités techniques, sociales et réglementaires du
            continent.
          </p>

          <h3 className="text-lg font-semibold mb-2">
            🔍 Ce que nous évaluons
          </h3>

          <ul className="list-disc list-inside text-gray-700 space-y-4">
            <li>
              <strong>🔐 Sécurité et protection des données</strong>
              <br />
              Respect des principes de confidentialité, intégrité et traçabilité
              des données de santé
              <br />
              Mesures de cybersécurité appropriées
              <br />
              Gestion du consentement et conformité aux législations locales et
              internationales
            </li>

            <li>
              <strong>⚙️ Robustesse technique et interopérabilité</strong>
              <br />
              Stabilité et performance de la solution dans des environnements à
              faible connectivité
              <br />
              Compatibilité avec d’autres systèmes (interopérabilité technique
              et sémantique)
              <br />
              Architecture logicielle claire, maintenance et documentation
              technique
            </li>

            <li>
              <strong>🧪 Crédibilité scientifique et validité médicale</strong>
              <br />
              Alignement avec des référentiels cliniques reconnus
              <br />
              Implication de professionnels de santé ou experts du domaine
              <br />
              Évidences cliniques, tests d’usage ou validation par des pairs
              (selon niveau de risque)
            </li>

            <li>
              <strong>👥 Pertinence socio-contextuelle</strong>
              <br />
              Accessibilité linguistique et culturelle (langues locales, usages
              courants)
              <br />
              Prise en compte des contextes de soins (zones rurales, ressources
              limitées…)
              <br />
              Expérience utilisateur adaptée aux professionnels et aux
              populations ciblées
            </li>

            <li>
              <strong>📈 Impact sanitaire et valeur ajoutée</strong>
              <br />
              Amélioration mesurable de la prévention, du diagnostic, du suivi
              ou de l’accès aux soins
              <br />
              Adéquation avec les priorités de santé publique nationales ou
              régionales
              <br />
              Potentiel de passage à l’échelle et d’intégration dans les
              politiques publiques
            </li>
          </ul>

          <p className="mt-4 text-gray-700">
            ✅ <strong>Pourquoi un tel cadre ?</strong>
            <br />
            Parce que le numérique en santé doit être un levier souverain,
            fiable et équitable pour transformer les systèmes de santé
            africains.
            <br />
            Le CEISNA offre ainsi aux développeurs, institutions et partenaires
            un outil de référence pour évaluer et reconnaître la valeur réelle
            des innovations numériques dans un esprit de rigueur, de
            transparence et d’accompagnement.
          </p>
        </div>

        <section>
          <h3 className="text-xl font-semibold mb-6">Rechercher</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Link
              to="/organisme/recherche"
              className="bg-white hover:shadow-md flex flex-col items-center rounded-lg shadow p-6 text-center"
            >
              <Barcode className="h-12 w-12 text-blue-600" />
              <h4 className="text-lg font-bold mb-2 text-blue-800">
                Certificats Organismes
              </h4>
              <p className="text-gray-600">
                Consultez et téléchargez les certificats officiels des
                organismes : fabricants, distributeurs, importateurs et
                représentants agréés.
              </p>
            </Link>
            <Link
              to="/certificats/promot/recherche"
              className="bg-white hover:shadow-md flex flex-col items-center rounded-lg shadow p-6 text-center"
            >
              <File className="h-12 w-12 text-blue-600" />
              <h4 className="text-lg font-bold mb-2 text-blue-800">
                Certificats Promoteurs
              </h4>
              <p className="text-gray-600">
                Explorez l’ensemble des certificats de vos promoteurs — délivrés
                ou refusés — et téléchargez-les en un clic.
              </p>
            </Link>

            <Link
              to="/certificats/e-vigilance/recherche"
              className="bg-white hover:shadow-md flex flex-col items-center rounded-lg shadow p-6 text-center transition"
            >
              <Eye className="w-12 h-12 text-blue-600 mb-4" />
              <h4 className="text-lg font-bold mb-2 text-blue-800">
                e‑Vigilance CEISNA
              </h4>
              <p className="text-gray-600">
                Consultez dossiers pharmacovigilance validés et certificats
                numériques, conformité et sécurité.
              </p>
            </Link>

            <Link
              to="/demande/labellisation"
              className="bg-white hover:shadow-md flex flex-col items-center rounded-lg shadow p-6 text-center transition"
            >
              <FolderPlus className="w-12 h-12 text-blue-600 mb-4" />
              <h4 className="text-lg font-bold mb-2 text-blue-800">
                Soumettez votre projet
              </h4>
              <p className="text-gray-600">
                Déposez vos documents et applications santé pour une
                certification rapide et fiable.
              </p>
            </Link>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-8">
              Experts CEISNA
            </h2>

            {error ? (
              <div className="text-center text-red-600 font-medium">
                Une erreur est survenue lors du chargement des experts. Veuillez
                réessayer plus tard.
              </div>
            ) : loading ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
                {Array.from({ length: 4 }).map((_, idx) => (
                  <div
                    key={idx}
                    className="flex flex-col items-center bg-white shadow-md rounded-lg p-6 animate-pulse"
                  >
                    <div className="w-24 h-24 bg-gray-200 rounded-full mb-4"></div>
                    <div className="h-4 bg-gray-200 rounded w-32 mb-2"></div>
                    <div className="h-3 bg-gray-200 rounded w-24 mb-1"></div>
                    <div className="h-3 bg-gray-200 rounded w-20"></div>
                  </div>
                ))}
              </div>
            ) : documents.length === 0 ? (
              <div className="text-center text-gray-600 italic">
                Aucun expert n&apos;a été trouvé pour le moment. Merci de
                revenir bientôt.
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
                {documents.map((expert) => (
                  <div
                    key={expert.id}
                    className="flex flex-col items-center bg-white shadow-md rounded-lg p-6"
                  >
                    <img
                      src={expert.imageSrc}
                      alt={expert.name}
                      className="w-24 h-24 rounded-full object-cover mb-4"
                    />
                    <h3 className="text-lg font-semibold text-gray-900">
                      {expert.name}
                    </h3>
                    <p className="text-sm text-blue-600">{expert.title}</p>
                    <p className="text-sm text-gray-500">{expert.country}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </section>
    </LabelsLayout>
  );
}
